import React from 'react';
import classnames from 'classnames';
import { plainList } from 'scy/utils.mod.scss';
import { flex } from 'scy/flex.mod.scss';
import styles from './styles.mod.scss';

export default function ProgressBar({ stepCount, step, hasWarning }) {
  return (
    <ol className={classnames(plainList, flex)}>
      {Array(stepCount)
        .fill(null)
        .map((_, i) => (
          <li
            key={i}
            className={classnames(styles.progressStep, {
              [styles.progressStepActive]: !hasWarning && step >= i + 1,
              [styles.progressStepInProgress]: !hasWarning && step === i,
              [styles.progressStepWarning]: hasWarning
            })}
          />
        ))}
    </ol>
  );
}
